import React from "react";
import PropTypes from "prop-types";
import BaseExitButton from "../BaseExitButton";
import useCookie from "../../hooks/useCookie";
import useCustomNavigate from "../../hooks/useCustomNavigate";
import ExitGameButton from "../ExitGameButton";
import "./style.scss";
import BackButton from "../BackButton";
import { useTranslation } from "react-i18next";
import BurgerMenu from "../BurgerMenu";
import ROUTES from "../../utils/routes";
import NavigateToLoginBtn from "../NavigatoToLoginBtn/NavigateToLoginBtn";

export default function BaseMobileHeader({
  isBtnLogout,
  isBtnExitGame,
  isBackBtn,
  isBurgerMenu,
  iconKeys,
  isHideInsightEvents,
  onClickBackBtn,
  loginBtn,
}) {
  const { removeCookie } = useCookie();
  const { navigateTo } = useCustomNavigate();
  BaseMobileHeader.propTypes = {
    isBtnLogout: PropTypes.bool,
    isBtnExitGame: PropTypes.bool,
    isBackBtn: PropTypes.bool,
    isBurgerMenu: PropTypes.bool,
    loginBtn: PropTypes.bool,
    onClickBackBtn: PropTypes.func,
    iconKeys: PropTypes.arrayOf(PropTypes.string),
  };
  const { t } = useTranslation();

  const logout = () => {
    removeCookie("token");
    navigateTo(ROUTES.LOGIN_PAGE);
  };
  return (
    <div
      className="mobile-header"
      style={{
        justifyContent:
          !isBtnExitGame && !isBackBtn ? "flex-end" : "space-between",
      }}
    >
      {isBtnLogout && (
        <BaseExitButton label={t("log_out")} onClick={() => logout()} />
      )}
      {isBtnExitGame && <ExitGameButton />}
      {isBackBtn && (
        <BackButton onClick={onClickBackBtn ? onClickBackBtn : null} />
      )}
      {isBurgerMenu && (
        <BurgerMenu
          isHideInsightEvents={isHideInsightEvents}
          iconKeys={iconKeys}
        />
      )}
      {loginBtn ? <NavigateToLoginBtn /> : null}
    </div>
  );
}
